/**
 * Decode HTML entities in a value that may have been encoded more than once.
 *
 * admin_messages.subject gains an htmlentities layer per save (sanitizeStr encodes every POST
 * field; retrieve_saveMessage only decodes `message` back), so "QA&Test" reads "QA&amp;amp;Test".
 * Display-side workaround - a subject typed literally as "AT&amp;T" gets decoded too.
 *
 * Layers only come from re-encoding an existing entity's "&", so collapse those and parse once.
 * Do NOT re-feed the parser its own output: "Amounts &lt;threshold" would resolve to a tag and
 * textContent would drop everything after it.
 */
const parser = new DOMParser();

const DecodeHtmlEntities = (value) => {
    if (value === null || value === undefined || value === '') {
        return '';
    }

    // Until stable, not a fixed count: each pass shortens the string, so it terminates.
    let collapsed = String(value);
    let previous;
    do {
        previous = collapsed;
        collapsed = collapsed.replace(/&amp;/g, '&');
    } while (collapsed !== previous);

    return parser.parseFromString(collapsed, 'text/html').body.textContent || '';
};

export default DecodeHtmlEntities;
